import { setNewbuildingBookingFailure, setNewbuildingBookingLoading, setNewbuildingBookingSuccess } from './actions';
import { selectOfferId } from '../../selectors';
import { fetchProfitbaseBooking } from '../../services/newbuildingBooking';
import { IThunkActionCreator } from '../../store';
import { trackBookingError } from '../../tracking/newbuildingBooking';

export const bookNewbuildingAction = (): IThunkActionCreator => {
  return async (dispatch, getState, { httpApi, logger }): Promise<void> => {
    try {
      const state = getState();
      const offerId = selectOfferId(state);

      dispatch(setNewbuildingBookingLoading());

      const bookingLink = await fetchProfitbaseBooking(httpApi, { offerId });

      dispatch(setNewbuildingBookingSuccess(bookingLink));
    } catch (error) {
      logger.error(error);
      dispatch(setNewbuildingBookingFailure());
      trackBookingError({ error: error.message });
    }
  };
};
